const prefix = 'file-upload';

export const dataHooks = {
  input: `${prefix}-input`,
};

export const CAPTURE = {
  user: 'user',
  environment: 'environment',
  none: 'none',
} as const;
